import { createContext, useContext } from "react";
import { useMutation } from "@apollo/client";
import {
  UPDATE_INCIDENT_NUMBER,
  UPDATE_CALL_TYPE,
  UPDATE_CALL_PRIORITY,
  UPDATE_INCIDENT_PRIORITY,
  UPDATE_CALL_ORIGIN,
  UPDATE_CALL_TIME,
  UPDATE_INCIDENT_ADDRESS,
  UPDATE_CALL_AREA,
  UPDATE_CALL_TEAM,
  UPDATE_ROLL_CALL,
  UPDATE_CALL_CANCELLED,
  UPDATE_STATEWIDE_EVENTS,
  UPDATE_DRUG_TYPES,
  UPDATE_OPIATE_BLOCKER,
  UPDATE_MENTAL_HEALTH,
  UPDATE_DOMV,
  UPDATE_CARGO_THEFT,
  SET_NARRATIVES,
  SET_QUERY_RETURNS,
  UPDATE_INCIDENT_FLAGS,
} from "../Mutations/IncidentMutations/UpdateIncident";
import {
  ADD_PIS,
  UPDATE_PIS_BAC,
  UPDATE_PIS_INCIDENT_INVOLVEMENT,
  UPDATE_PIS_PERSON,
  UPDATE_PIS_CLOTHING,
  UPDATE_PIS_COMPUTER_USE,
  UPDATE_PIS_DOC_STATUS,
  UPDATE_PIS_DRUG_TYPES,
  UPDATE_PIS_IBR_RESIDENT_TYPE,
  UPDATE_PIS_INJURY_TYPES,
  UPDATE_PIS_OPIATE_BLOCKER,
  UPDATE_PIS_ORPHANAGE,
  UPDATE_PIS_PAPERWORK,
  UPDATE_PIS_SEALED,
  UPDATE_PIS_STATEMENT_TAKEN_BY,
  UPDATE_PIS_STATEMENT_TYPE,
  UPDATE_PIS_VICTIM_TYPE,
  UPDATE_PIS_WEAPON_TYPE,
} from "../Mutations/IncidentMutations/UpdatePersonInIncident";
//eventually update to use the person mutations already present here
import { ADD_OR_UPDATE_PERSON_IN_INCIDENT } from "../Mutations/AddOrUpdatePersonInIncident";
import { ADD_OR_UPDATE_PERSON } from "../Mutations/AddOrUpdatePerson";
import {
  UPDATE_PERSON_ORGANIZATION,
  UPDATE_PERSON_FIRSTNAME,
  UPDATE_PERSON_LASTNAME,
  UPDATE_PERSON_MIDDLENAME,
  UPDATE_PERSON_SUFFIX,
  UPDATE_PERSON_JUVENILE,
  UPDATE_PERSON_DOB,
  UPDATE_PERSON_HOME_ADDRESS,
  UPDATE_PERSON_POB_ADDRESS,
  UPDATE_PERSON_MAILING_ADDRESS,
  UPDATE_PERSON_EMPLOYER_ADDRESS,
  UPDATE_PERSON_GENDER,
  UPDATE_PERSON_NIBRS_GENDER,
  UPDATE_PERSON_RACE,
  UPDATE_PERSON_HEIGHT,
  UPDATE_PERSON_WEIGHT,
  UPDATE_PERSON_SCHOOL,
  UPDATE_PERSON_BUILD,
  UPDATE_PERSON_ALIAS,
  UPDATE_PERSON_HAIR_COLOR,
  UPDATE_PERSON_EYE_COLOR,
  UPDATE_PERSON_FACIAL_HAIR,
  UPDATE_PERSON_HAIR_LENGTH,
  UPDATE_PERSON_DISTINGUISHING_CHARACTERISTICS,
  UPDATE_PERSON_DECEASED,
  UPDATE_PERSON_SID,
  UPDATE_PERSON_FBI,
  UPDATE_PERSON_CELL,
  UPDATE_PERSON_PHONE,
  UPDATE_PERSON_EMAIL,
  UPDATE_PERSON_DRIVERS_LICENSE,
  UPDATE_PERSON_LICENSE_STATE,
  UPDATE_PERSON_IBR_GANG_AFFILIATIONS,
  UPDATE_PERSON_IBR_RACE,
  UPDATE_PERSON_EMPLOYER,
  UPDATE_PERSON_GROUP,
} from "../Mutations/IncidentMutations/UpdatePersonDetail";
import {
  UPDATE_VIS_ABANDONED,
  UPDATE_VIS_IMPOUNDED,
  UPDATE_VIS_OPERATOR,
  UPDATE_VIS_REASON_SEIZED,
  UPDATE_VIS_SUSPECT_DRIVEN,
  UPDATE_VIS_WRECKER,
  UPDATE_VIS_TOWING_DESTINATION,
  UPDATE_VIS_USED_IN_CRIME,
  UPDATE_VIS_VEHICLE_OF_INTEREST,
  UPDATE_VIS_VEHICLE_ROLE,
  UPDATE_VIS_POSITION,
} from "../Mutations/IncidentMutations/UpdateVehicleInIncident";
import {
  UPDATE_VEHICLE_DESCRIPTION,
  UPDATE_VEHICLE_OWNER,
  UPDATE_VEHICLE_PLATE_TYPE,
  UPDATE_VEHICLE_VALUE,
  UPDATE_VEHICLE_COLOR,
  UPDATE_VEHICLE_MAKE,
  UPDATE_VEHICLE_MODEL,
  UPDATE_VEHICLE_PLATE,
  UPDATE_VEHICLE_STATE,
  UPDATE_VEHICLE_VIN,
  UPDATE_VEHICLE_YEAR,
  UPDATE_VEHICLE_ALL_FIELDS,
} from "../Mutations/IncidentMutations/UpdateVehicle";
import {
  UPDATE_TICKET_ACCIDENT,
  UPDATE_TICKET_ACTUAL_SPEED,
  UPDATE_TICKET_CDL,
  UPDATE_TICKET_CODE,
  UPDATE_TICKET_COMMERCIAL_VEHICLE,
  UPDATE_TICKET_CURRENT_STATUS,
  UPDATE_TICKET_CV_HAZARD_FEE,
  UPDATE_TICKET_DEFENDANT_ACTIONS,
  UPDATE_TICKET_DEFENDANT_PARENT,
  UPDATE_TICKET_DELIVERED_TO,
  UPDATE_TICKET_DISPOSITION_PENALTY_AMOUNT,
  UPDATE_TICKET_FATALITY,
  UPDATE_TICKET_VIOLATION_TYPE,
  UPDATE_TICKET_HAZMAT,
  UPDATE_TICKET_HIGHWAY,
  UPDATE_TICKET_ISSUED_AT,
  UPDATE_TICKET_ISSUED_TO,
  UPDATE_TICKET_IS_WARNING,
  UPDATE_TICKET_ISSUED_TO_ADDRESS,
  UPDATE_TICKET_LOCKED,
  UPDATE_TICKET_MAILING_ADDRESS_VERIFIED,
  UPDATE_TICKET_MUNICIPAL_ORDINANCE,
  UPDATE_TICKET_MUNICIPALITY,
  UPDATE_TICKET_NARRATIVE,
  UPDATE_TICKET_OFFICER,
  UPDATE_TICKET_OPERATOR,
  UPDATE_TICKET_PASSENGER_TICKET_EVIDENCE,
  UPDATE_TICKET_PASSENGER_TICKET_OUTCOME,
  UPDATE_TICKET_PASSENGER_TICKET_SEARCH,
  UPDATE_TICKET_PENALTY,
  UPDATE_TICKET_PENALTY_MAX,
  UPDATE_TICKET_PENALTY_MIN,
  UPDATE_TICKET_PERCEIVED_RACE,
  UPDATE_TICKET_POINTS,
  UPDATE_TICKET_POSTED_LIMIT,
  UPDATE_TICKET_RELATIVE_CRIME_CHARGE,
  UPDATE_TICKET_RELIEF_ACT_COMMENT,
  UPDATE_TICKET_RELIEF_ACT_TYPE,
  UPDATE_TICKET_RESTITUTION,
  UPDATE_TICKET_SEAT_BELT_OCCURRENCE,
  UPDATE_TICKET_SEAT_BELT_VIOLATION,
  UPDATE_TICKET_SPEED_MEASUREMENT,
  UPDATE_TICKET_DELIVERY_TYPE,
  UPDATE_TICKET_EVIDENCE,
  UPDATE_TICKET_LOCATION,
  UPDATE_TICKET_NUMBER,
  UPDATE_TICKET_OUTCOME,
  UPDATE_TICKET_SEARCH,
  UPDATE_TICKET_STATUS,
  UPDATE_TICKET_STOP,
  UPDATE_TICKET_FEDERAL_VIOLATION_CODE,
  UPDATE_TICKET_TRESPASS_REQUESTOR,
  UPDATE_TICKET_TRESPASS_UNTIL,
  UPDATE_TICKET_UOF_INJURY_DETAILS,
  UPDATE_TICKET_UOF_INSTANCE,
  UPDATE_TICKET_UOF_INSTANCE_TYPES,
  UPDATE_TICKET_VEHICLE,
  UPDATE_TICKET_VIOLATION_DATE,
  UPDATE_TICKET_WAIVER,
  UPDATE_TICKET_ALL_FIELDS,
  UPDATE_TICKET_WEIGHT_LIMIT,
  UPDATE_TICKET_SEAT_VIOLATION_OCCURRENCE,
} from "../Mutations/IncidentMutations/UpdateTicket";
import { UPDATE_TICKET_CONDITION } from "../Mutations/IncidentMutations/UpdateTicketCondition";
import { REMOVE_VEHICLE_FROM_INCIDENT } from "../Mutations/IncidentMutations/RemoveVehicleFromIncident";
import { UPDATE_INCIDENT_DETAIL_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdateIncidentDetail";
import { ADD_OR_UPDATE_INCIDENT_NARRATIVE } from "../Mutations/IncidentMutations/UpdateIncidentNarrative";
import { REMOVE_INCIDENT_NARRATIVE } from "../Mutations/IncidentMutations/RemoveIncidentNarrative";
import { UPDATE_OFFENSE_IN_INCIDENT_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdateOffenseInIncident";
import { REMOVE_OFFENSE_FROM_INCIDENT } from "../Mutations/IncidentMutations/RemoveOffenseFromIncident";
import { UPDATE_SVA_IN_OFFENSE } from "../Mutations/IncidentMutations/UpdateSvaInOffense";
import { REMOVE_SVA_FROM_OFFENSE } from "../Mutations/IncidentMutations/RemoveSvaFromOffense";
import { ADD_OR_UPDATE_OFFICER_IN_INCIDENT } from "../Mutations/AddOrUpdateOfficerInIncident";
import { SET_OFFICER_INCIDENT_TIMES } from "../Mutations/SetOfficerIncidentTimes";
import { SET_STATUS } from "../Mutations/SetStatus";
import { UPDATE_ARREST_INCIDENT_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdateArrestInIncident";
import { REMOVE_ARREST_FROM_INCIDENT } from "../Mutations/IncidentMutations/RemoveArrestFromIncident";
import { UPDATE_CHARGE_IN_ARREST_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdateChargeInArrest";
import { REMOVE_CHARGE_FROM_ARREST } from "../Mutations/IncidentMutations/RemoveChargeFromArrest";
import { UPDATE_PROPERTY_IN_INCIDENT_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdatePropertyInIncident";
import { REMOVE_PROPERTY_FROM_INCIDENT } from "../Mutations/IncidentMutations/RemovePropertyFromIncident";
import { UPDATE_CUSTODY_CHAIN_IN_PROPERTY_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdateCustodyChainInProperty";
import { REMOVE_CUSTODY_CHAIN_FROM_PROPERTY } from "../Mutations/IncidentMutations/RemoveCustodyChainFromProperty";
import { UPDATE_LAB_ANALYSIS_INSTANCE_IN_PROPERTY_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdateLabAnalysisInstanceInProperty";
import { REMOVE_LAB_ANALYSIS_INSTANCE_FROM_PROPERTY } from "../Mutations/IncidentMutations/RemoveLabAnalysisInstanceFromProperty";
import { UPDATE_INCIDENT_REVIEW_ALL_FIELDS } from "../Mutations/IncidentMutations/UpdateIncidentReview";
import { ADD_OR_UPDATE_NIC_ENTRY } from "../Mutations/AddOrUpdateNicEntry";
import { REMOVE_NIC_ENTRY } from "../Mutations/RemoveNicEntry";
import { ADD_ADDRESS_ALERT } from "../Mutations/AddAddressAlert";
import { REMOVE_ADDRESS_ALERT } from "../Mutations/RemoveAddressAlert";
import { ADD_PERSON_ALERT } from "../Mutations/AddPersonAlert";
import { REMOVE_PERSON_ALERT } from "../Mutations/RemovePersonAlert";
import { ADD_VEHICLE_ALERT } from "../Mutations/AddVehicleAlert";
import { REMOVE_VEHICLE_ALERT } from "../Mutations/RemoveVehicleAlert";
import { IncidentsContext } from "./IncidentsContext";
import { INCIDENT_ACTIONS } from "../Actions/IncidentActions";
import { ACTIVE_INCIDENTS_ACTIONS } from "../Actions/ActiveIncidentsActions";
import { DashboardContext } from "./DashboardContext";
import { UPDATE_SPEED_MEASUREMENT } from "../Mutations/IncidentMutations/UpdateSpeedMeasurement";
import { GENERATE_TICKET_NUMBER } from "../Mutations/GenerateTicketNumber";
import { UserContext } from "./UserContext";
import { throttleFunction } from "../utils/throttleFunction";
import { ADD_OR_UPDATE_POLD_INSTANCE_IN_INCIDENT } from "../Mutations/AddOrUpdatePoldInstanceInIncident";
export const MutationContext = createContext();

const MutationContextProvider = props => {
  const { incidentDispatch } = useContext(IncidentsContext);
  const { activeIncidentDispatch } = useContext(DashboardContext);
  const {
    UPDATE_INCIDENT,
    UPDATE_PIS,
    UPDATE_PERSON_IN_PIS,
    UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
    UPDATE_VEHICLE,
    UPDATE_VIS,
    UPDATE_OFFENSE,
    UPDATE_SVA_ALL_INCIDENTS,
    UPDATE_ARREST,
    UPDATE_CHARGE_ALL_INCIDENTS,
    UPDATE_PROPERTY,
    UPDATE_CUSTODY_CHAIN,
    UPDATE_LAB_ANALYSIS,
    UPDATE_INCIDENT_REVIEW,
    UPDATE_NIC,
    UPDATE_INCIDENT_ADDRESS_ALERT,
    UPDATE_INCIDENT_TICKET,
    UPDATE_INCIDENT_DETAIL_NARRATIVE,
  } = INCIDENT_ACTIONS;
  const { UPDATE_ACTIVE_INCIDENT_PROPERTY, UPDATE_OIS } =
    ACTIVE_INCIDENTS_ACTIONS;
  const { responseErrorHandler } = useContext(UserContext);
  //Mutations for the incident
  const [updateIncidentNumber] = useMutation(UPDATE_INCIDENT_NUMBER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "incidentNumber",
            value: incident.incidentNumber,
          },
        });
        activeIncidentDispatch({
          type: UPDATE_ACTIVE_INCIDENT_PROPERTY,
          payload: {
            incidentId: incident.id ? incident.id : incident.uuid,
            property: "incidentNumber",
            value: incident.incidentNumber,
          },
        });
      }
    },
  });
  const [updateCallType] = useMutation(UPDATE_CALL_TYPE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "classification",
            value: incident.classification,
          },
        });
        activeIncidentDispatch({
          type: UPDATE_ACTIVE_INCIDENT_PROPERTY,
          payload: {
            incidentId: incident.id ? incident.id : incident.uuid,
            property: "classification",
            value: incident.classification,
          },
        });
      }
    },
  });
  const [updateCallPriority] = useMutation(UPDATE_CALL_PRIORITY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "callPriority",
            value: incident.callPriority,
          },
        });
      }
    },
  });
  const [updateIncidentPriority] = useMutation(UPDATE_INCIDENT_PRIORITY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "incidentPriority",
            value: incident.incidentPriority,
          },
        });
      }
    },
  });
  const [updateCallOrigin] = useMutation(UPDATE_CALL_ORIGIN, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "incidentOrigin",
            value: incident.incidentOrigin,
          },
        });
      }
    },
  });
  const [updateCallTime] = useMutation(UPDATE_CALL_TIME, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "callTime",
            value: incident.callTime,
          },
        });
      }
    },
  });
  const [updateIncidentAddress] = useMutation(UPDATE_INCIDENT_ADDRESS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "address",
            value: incident.address,
          },
        });
        activeIncidentDispatch({
          type: UPDATE_ACTIVE_INCIDENT_PROPERTY,
          payload: {
            incidentId: incident.id ? incident.id : incident.uuid,
            property: "address",
            value: incident.address,
          },
        });
      }
    },
  });
  const [updateCallArea] = useMutation(UPDATE_CALL_AREA, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "area",
            value: incident.area,
          },
        });
      }
    },
  });
  const [updateCallTeam] = useMutation(UPDATE_CALL_TEAM, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "team",
            value: incident.team,
          },
        });
      }
    },
  });
  const [updateRollCall] = useMutation(UPDATE_ROLL_CALL, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "rollCall",
            value: incident.rollCall,
          },
        });
      }
    },
  });
  const [updateCallCancelled] = useMutation(UPDATE_CALL_CANCELLED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "callCancelled",
            value: incident.callCancelled,
          },
        });
      }
    },
  });
  const [updateStatewideEvents] = useMutation(UPDATE_STATEWIDE_EVENTS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "stateWideEvents",
            value: incident.stateWideEvents,
          },
        });
      }
    },
  });
  const [updateDrugTypes] = useMutation(UPDATE_DRUG_TYPES, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "drugTypes",
            value: incident.drugTypes,
          },
        });
      }
    },
  });

  const [updatePold] = useMutation(ADD_OR_UPDATE_POLD_INSTANCE_IN_INCIDENT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const { poldInstance } = data[Object.keys(data)[0]] || {};

        if (poldInstance && poldInstance?.incident?.id)
          incidentDispatch({
            type: UPDATE_INCIDENT,
            payload: {
              id: poldInstance?.incident?.id,
              property: "poldInstance",
              value: poldInstance,
            },
          });
      }
    },
  });
  const [updateIncidentFlags] = useMutation(UPDATE_INCIDENT_FLAGS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "incidentFlags",
            value: incident.incidentFlags,
          },
        });
      }
    },
  });

  const [updateOpiateBlocker] = useMutation(UPDATE_OPIATE_BLOCKER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "opiateBlocker",
            value: incident.opiateBlocker,
          },
        });
      }
    },
  });
  const [updateMentalHealth] = useMutation(UPDATE_MENTAL_HEALTH, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "mentalHealthRelated",
            value: incident.mentalHealthRelated,
          },
        });
      }
    },
  });
  const [updateDomv] = useMutation(UPDATE_DOMV, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "domv",
            value: incident.domv,
          },
        });
      }
    },
  });
  const [updateCargoTheft] = useMutation(UPDATE_CARGO_THEFT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const incident = data[Object.keys(data)[0]].incident;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: incident.id,
            uuid: incident.uuid,
            property: "cargoTheft",
            value: incident.cargoTheft,
          },
        });
      }
    },
  });
  const [setNarratives] = useMutation(SET_NARRATIVES, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        const narratives = data[Object.keys(data)[0]].narratives;
        const id = data[Object.keys(data)[0]].incidentUuid;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: id,
            uuid: id,
            property: "narratives",
            value: narratives,
          },
        });
      }
    },
  });
  const [setQueryReturns] = useMutation(SET_QUERY_RETURNS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        const queryReturns = data[Object.keys(data)[0]].queryReturns;
        const id = data[Object.keys(data)[0]].incidentUuid;
        incidentDispatch({
          type: UPDATE_INCIDENT,
          payload: {
            id: id,
            uuid: id,
            property: "queryReturns",
            value: queryReturns,
          },
        });
      }
    },
  });

  //Mutations for the personIncidentSpecific
  //ADD_PIS now returns the incidentUuid, pisUuid, and personUuid as well as the entire pis
  const [addPis] = useMutation(ADD_PIS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        incidentDispatch({
          type: UPDATE_PIS,
          payload: {
            incidentId: data[Object.keys(data)[0]]?.incidentUuid,
            pisId: data[Object.keys(data)[0]].personIncidentSpecificUuid,
            property: "id",
            value: data[Object.keys(data)[0]].personIncidentSpecific.id,
          },
        });
        incidentDispatch({
          type: UPDATE_PERSON_IN_PIS,
          payload: {
            incidentId: data[Object.keys(data)[0]]?.incidentUuid,
            pisId: data[Object.keys(data)[0]].personIncidentSpecificUuid,
            property: "id",
            value: data[Object.keys(data)[0]].personIncidentSpecific.person.id,
          },
        });
        incidentDispatch({
          type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
          payload: {
            personId:
              data[Object.keys(data)[0]].personIncidentSpecific.person.id,
            personUuid: data[Object.keys(data)[0]].personUuid,
            property: "id",
            value:
              data[Object.keys(data)[0]].personIncidentSpecific.person
                .personalAttribute.id,
          },
        });
      }
    },
  });

  const throttledAddPis = throttleFunction(addPis);

  const [updatePisBac] = useMutation(UPDATE_PIS_BAC, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisIncidentInvolvement] = useMutation(
    UPDATE_PIS_INCIDENT_INVOLVEMENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          const pis = data[Object.keys(data)[0]].personIncidentSpecific;
          incidentDispatch({
            type: UPDATE_PIS,
            payload: {
              incidentId: data[Object.keys(data)[0]]?.incidentUuid,
              pisId: pis?.id,
              pisUuid: data[Object.keys(data)[0]]?.personIncidentSpecificUuid,
              property: "incidentInvolvement",
              value: pis?.incidentInvolvement,
            },
          });
        }
      },
    }
  );
  const [updatePisPerson] = useMutation(UPDATE_PIS_PERSON, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisClothing] = useMutation(UPDATE_PIS_CLOTHING, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisComputerUse] = useMutation(UPDATE_PIS_COMPUTER_USE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisDocStatus] = useMutation(UPDATE_PIS_DOC_STATUS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisDrugTypes] = useMutation(UPDATE_PIS_DRUG_TYPES, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisIbrResidentType] = useMutation(UPDATE_PIS_IBR_RESIDENT_TYPE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisInjuryTypes] = useMutation(UPDATE_PIS_INJURY_TYPES, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisOpiateBlocker] = useMutation(UPDATE_PIS_OPIATE_BLOCKER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisOrphanage] = useMutation(UPDATE_PIS_ORPHANAGE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisPaperwork] = useMutation(UPDATE_PIS_PAPERWORK, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisSealed] = useMutation(UPDATE_PIS_SEALED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisStateTakenBy] = useMutation(UPDATE_PIS_STATEMENT_TAKEN_BY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisStatementType] = useMutation(UPDATE_PIS_STATEMENT_TYPE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisVictimType] = useMutation(UPDATE_PIS_VICTIM_TYPE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePisWeaponType] = useMutation(UPDATE_PIS_WEAPON_TYPE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });

  //Mutations for a person
  const [updatePersonOrganization] = useMutation(UPDATE_PERSON_ORGANIZATION, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const person = data[Object.keys(data)[0]].person;
        incidentDispatch({
          type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
          payload: {
            property: "organization",
            personId: person?.id
              ? person.id
              : data[Object.keys(data)[0]].personUuid,
            value: person.personalAttribute.organization,
          },
        });
      }
    },
  });
  const [updatePersonFirstName] = useMutation(UPDATE_PERSON_FIRSTNAME, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonMiddleName] = useMutation(UPDATE_PERSON_MIDDLENAME, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonLastName] = useMutation(UPDATE_PERSON_LASTNAME, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonSuffix] = useMutation(UPDATE_PERSON_SUFFIX, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonJuvenile] = useMutation(UPDATE_PERSON_JUVENILE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonDob] = useMutation(UPDATE_PERSON_DOB, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const person = data[Object.keys(data)[0]].person;
        incidentDispatch({
          type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
          payload: {
            property: "dob",
            personId: person?.id
              ? person.id
              : data[Object.keys(data)[0]].personUuid,
            value: person.personalAttribute.dob,
          },
        });
      }
    },
  });
  const [updatePersonHomeAddress] = useMutation(UPDATE_PERSON_HOME_ADDRESS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const person = data[Object.keys(data)[0]].person;
        incidentDispatch({
          type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
          payload: {
            property: "homeAddress",
            personId: person?.id
              ? person.id
              : data[Object.keys(data)[0]].personUuid,
            value: person.personalAttribute.homeAddress,
          },
        });
      }
    },
  });
  const [updatePersonPobAddress] = useMutation(UPDATE_PERSON_POB_ADDRESS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonMailingAddress] = useMutation(
    UPDATE_PERSON_MAILING_ADDRESS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updatePersonEmployerAddress] = useMutation(
    UPDATE_PERSON_EMPLOYER_ADDRESS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updatePersonGender] = useMutation(UPDATE_PERSON_GENDER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonNibrsGender] = useMutation(UPDATE_PERSON_NIBRS_GENDER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonRace] = useMutation(UPDATE_PERSON_RACE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonHeight] = useMutation(UPDATE_PERSON_HEIGHT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonWeight] = useMutation(UPDATE_PERSON_WEIGHT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonSchool] = useMutation(UPDATE_PERSON_SCHOOL, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonBuild] = useMutation(UPDATE_PERSON_BUILD, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonAlias] = useMutation(UPDATE_PERSON_ALIAS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonHairColor] = useMutation(UPDATE_PERSON_HAIR_COLOR, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonEyeColor] = useMutation(UPDATE_PERSON_EYE_COLOR, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonFacialHair] = useMutation(UPDATE_PERSON_FACIAL_HAIR, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonHairLength] = useMutation(UPDATE_PERSON_HAIR_LENGTH, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonDistinguishingCharacteristics] = useMutation(
    UPDATE_PERSON_DISTINGUISHING_CHARACTERISTICS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updatePersonDeceased] = useMutation(UPDATE_PERSON_DECEASED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonSid] = useMutation(UPDATE_PERSON_SID, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonFbi] = useMutation(UPDATE_PERSON_FBI, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonCell] = useMutation(UPDATE_PERSON_CELL, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonPhone] = useMutation(UPDATE_PERSON_PHONE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const person = data[Object.keys(data)[0]].person;
        incidentDispatch({
          type: UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS,
          payload: {
            property: "phone",
            personId: person?.id
              ? person.id
              : data[Object.keys(data)[0]].personUuid,
            value: person.personalAttribute.phone,
          },
        });
      }
    },
  });
  const [updatePersonEmail] = useMutation(UPDATE_PERSON_EMAIL, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonDriversLicense] = useMutation(
    UPDATE_PERSON_DRIVERS_LICENSE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updatePersonLicenseState] = useMutation(UPDATE_PERSON_LICENSE_STATE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonIbrGangAffiliations] = useMutation(
    UPDATE_PERSON_IBR_GANG_AFFILIATIONS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updatePersonIbrRace] = useMutation(UPDATE_PERSON_IBR_RACE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonEmployer] = useMutation(UPDATE_PERSON_EMPLOYER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updatePersonGroups] = useMutation(UPDATE_PERSON_GROUP, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  //Mutations for VIS
  const [updateVisAbandoned] = useMutation(UPDATE_VIS_ABANDONED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVisImpounded] = useMutation(UPDATE_VIS_IMPOUNDED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVisOperator] = useMutation(UPDATE_VIS_OPERATOR, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const res = data[Object.keys(data)[0]];
        const incidentUuid = res?.incidentUuid;
        const vis = res?.vehicleIncidentSpecific;
        const visUuid = res?.vehicleIncidentSpecificUuid;
        const incidentId = res?.vehicleIncidentSpecific?.incident?.id;
        const operator = vis?.operator;
        incidentDispatch({
          type: UPDATE_VIS,
          payload: {
            incidentId: incidentId,
            incidentUuid: incidentUuid,
            visId: vis?.id,
            visUuid: visUuid,
            property: "operator",
            value: operator,
          },
        });
      }
    },
  });
  const [updateVisReasonSeized] = useMutation(UPDATE_VIS_REASON_SEIZED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVisSuspectDriven] = useMutation(UPDATE_VIS_SUSPECT_DRIVEN, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVisWrecker] = useMutation(UPDATE_VIS_WRECKER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVisTowingDestination] = useMutation(
    UPDATE_VIS_TOWING_DESTINATION,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateVisUsedInCrime] = useMutation(UPDATE_VIS_USED_IN_CRIME, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVisVehicleOfInterest] = useMutation(
    UPDATE_VIS_VEHICLE_OF_INTEREST,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateVisVehicleRole] = useMutation(UPDATE_VIS_VEHICLE_ROLE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVisPosition] = useMutation(UPDATE_VIS_POSITION, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  //************* Mutations for vehicles *************//
  const [updateVehicleAllFields] = useMutation(UPDATE_VEHICLE_ALL_FIELDS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const vehicle = data[Object.keys(data)[0]]?.vehicle;
        incidentDispatch({
          type: UPDATE_VEHICLE,
          payload: {
            vehicleId: vehicle?.id ? vehicle.id : vehicle?.uuid,
            property: "description",
            value: vehicle.description,
          },
        });
      }
    },
  });
  const [updateVehicleDescription] = useMutation(UPDATE_VEHICLE_DESCRIPTION, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const vehicle = data[Object.keys(data)[0]]?.vehicle;
        incidentDispatch({
          type: UPDATE_VEHICLE,
          payload: {
            vehicleId: vehicle?.id ? vehicle.id : vehicle?.uuid,
            property: "description",
            value: vehicle.description,
          },
        });
      }
    },
  });
  const [updateVehicleOwner] = useMutation(UPDATE_VEHICLE_OWNER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const vehicle = data[Object.keys(data)[0]]?.vehicle;
        const vehicleUuid = data[Object.keys(data)[0]]?.vehicleUuid;
        incidentDispatch({
          type: UPDATE_VEHICLE,
          payload: {
            vehicleId: vehicle?.id,
            vehicleUuid: vehicleUuid,
            property: "owner",
            value: vehicle?.owner,
          },
        });
      }
    },
  });
  const [updateVehiclePlateType] = useMutation(UPDATE_VEHICLE_PLATE_TYPE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const vehicle = data[Object.keys(data)[0]]?.vehicle;
        incidentDispatch({
          type: UPDATE_VEHICLE,
          payload: {
            vehicleId: vehicle?.id ? vehicle.id : vehicle?.uuid,
            property: "plateType",
            value: vehicle.plateType,
          },
        });
      }
    },
  });
  const [updateVehicleValue] = useMutation(UPDATE_VEHICLE_VALUE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVehicleColor] = useMutation(UPDATE_VEHICLE_COLOR, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVehicleMake] = useMutation(UPDATE_VEHICLE_MAKE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVehicleModel] = useMutation(UPDATE_VEHICLE_MODEL, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVehiclePlate] = useMutation(UPDATE_VEHICLE_PLATE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVehicleState] = useMutation(UPDATE_VEHICLE_STATE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const vehicle = data[Object.keys(data)[0]]?.vehicle;
        incidentDispatch({
          type: UPDATE_VEHICLE,
          payload: {
            vehicleId: vehicle?.id ? vehicle.id : vehicle?.uuid,
            property: "vehicleState",
            value: vehicle.vehicleState,
          },
        });
      }
    },
  });
  const [updateVehicleVin] = useMutation(UPDATE_VEHICLE_VIN, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateVehicleYear] = useMutation(UPDATE_VEHICLE_YEAR, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        const vehicle = data[Object.keys(data)[0]]?.vehicle;
        incidentDispatch({
          type: UPDATE_VEHICLE,
          payload: {
            vehicleId: vehicle?.id ? vehicle.id : vehicle?.uuid,
            property: "year",
            value: vehicle.year,
          },
        });
      }
    },
  });
  //Tickets
  const [generateTicketNumber] = useMutation(GENERATE_TICKET_NUMBER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketAccident] = useMutation(UPDATE_TICKET_ACCIDENT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketActualSpeed] = useMutation(UPDATE_TICKET_ACTUAL_SPEED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketCdl] = useMutation(UPDATE_TICKET_CDL, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketCode] = useMutation(UPDATE_TICKET_CODE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketCommercialVehicle] = useMutation(
    UPDATE_TICKET_COMMERCIAL_VEHICLE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketCurrentStatus] = useMutation(
    UPDATE_TICKET_CURRENT_STATUS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketCvHazardFee] = useMutation(UPDATE_TICKET_CV_HAZARD_FEE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketDefendantActions] = useMutation(
    UPDATE_TICKET_DEFENDANT_ACTIONS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketDefendantParent] = useMutation(
    UPDATE_TICKET_DEFENDANT_PARENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketDeliveredTo] = useMutation(UPDATE_TICKET_DELIVERED_TO, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketDispositionPenaltyAmount] = useMutation(
    UPDATE_TICKET_DISPOSITION_PENALTY_AMOUNT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketFatality] = useMutation(UPDATE_TICKET_FATALITY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketViolationType] = useMutation(
    UPDATE_TICKET_VIOLATION_TYPE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketHazmat] = useMutation(UPDATE_TICKET_HAZMAT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketHighway] = useMutation(UPDATE_TICKET_HIGHWAY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketIssuedAt] = useMutation(UPDATE_TICKET_ISSUED_AT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketIssuedTo] = useMutation(UPDATE_TICKET_ISSUED_TO, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketIssuedToAddress] = useMutation(
    UPDATE_TICKET_ISSUED_TO_ADDRESS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketIsWarning] = useMutation(UPDATE_TICKET_IS_WARNING, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketLocked] = useMutation(UPDATE_TICKET_LOCKED, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketMailingAddressVerified] = useMutation(
    UPDATE_TICKET_MAILING_ADDRESS_VERIFIED,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketMunicipalOrdinance] = useMutation(
    UPDATE_TICKET_MUNICIPAL_ORDINANCE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketMunicipality] = useMutation(UPDATE_TICKET_MUNICIPALITY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketNarrative] = useMutation(UPDATE_TICKET_NARRATIVE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketOfficer] = useMutation(UPDATE_TICKET_OFFICER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketOperator] = useMutation(UPDATE_TICKET_OPERATOR, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketPassengerTicketEvidence] = useMutation(
    UPDATE_TICKET_PASSENGER_TICKET_EVIDENCE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketPassengerTicketOutcome] = useMutation(
    UPDATE_TICKET_PASSENGER_TICKET_OUTCOME,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketPassengerTicketSearch] = useMutation(
    UPDATE_TICKET_PASSENGER_TICKET_SEARCH,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketPenalty] = useMutation(UPDATE_TICKET_PENALTY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketPenaltyMax] = useMutation(UPDATE_TICKET_PENALTY_MAX, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketPenaltyMin] = useMutation(UPDATE_TICKET_PENALTY_MIN, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketPerceivedRace] = useMutation(
    UPDATE_TICKET_PERCEIVED_RACE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketPoints] = useMutation(UPDATE_TICKET_POINTS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketPostedLimit] = useMutation(UPDATE_TICKET_POSTED_LIMIT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketRelativeCrimeCharge] = useMutation(
    UPDATE_TICKET_RELATIVE_CRIME_CHARGE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketReliefActComment] = useMutation(
    UPDATE_TICKET_RELIEF_ACT_COMMENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketReliefActType] = useMutation(
    UPDATE_TICKET_RELIEF_ACT_TYPE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketRestitution] = useMutation(UPDATE_TICKET_RESTITUTION, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketSeatBeltOccurrence] = useMutation(
    UPDATE_TICKET_SEAT_BELT_OCCURRENCE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketViolationOccurrence] = useMutation(
    UPDATE_TICKET_SEAT_VIOLATION_OCCURRENCE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketSeatBeltViolation] = useMutation(
    UPDATE_TICKET_SEAT_BELT_VIOLATION,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketSpeedMeasurement] = useMutation(
    UPDATE_TICKET_SPEED_MEASUREMENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketDeliveryType] = useMutation(UPDATE_TICKET_DELIVERY_TYPE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketEvidence] = useMutation(UPDATE_TICKET_EVIDENCE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketLocation] = useMutation(UPDATE_TICKET_LOCATION, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketNumber] = useMutation(UPDATE_TICKET_NUMBER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketOutcome] = useMutation(UPDATE_TICKET_OUTCOME, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketSearch] = useMutation(UPDATE_TICKET_SEARCH, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketStatus] = useMutation(UPDATE_TICKET_STATUS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketStop] = useMutation(UPDATE_TICKET_STOP, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketFederalViolationCode] = useMutation(
    UPDATE_TICKET_FEDERAL_VIOLATION_CODE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketTrespassRequestor] = useMutation(
    UPDATE_TICKET_TRESPASS_REQUESTOR,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketTrespassUntil] = useMutation(
    UPDATE_TICKET_TRESPASS_UNTIL,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketUofInjuryDetails] = useMutation(
    UPDATE_TICKET_UOF_INJURY_DETAILS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketUofInstance] = useMutation(UPDATE_TICKET_UOF_INSTANCE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketUofInstanceTypes] = useMutation(
    UPDATE_TICKET_UOF_INSTANCE_TYPES,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketVehicle] = useMutation(UPDATE_TICKET_VEHICLE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketViolationDate] = useMutation(
    UPDATE_TICKET_VIOLATION_DATE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateTicketWaiver] = useMutation(UPDATE_TICKET_WAIVER, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketWeightLimit] = useMutation(UPDATE_TICKET_WEIGHT_LIMIT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [updateTicketAllFields] = useMutation(UPDATE_TICKET_ALL_FIELDS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        if (data[Object.keys(data)[0]].ticketUuid?.includes("Offline_")) {
          incidentDispatch({
            type: UPDATE_INCIDENT_TICKET,
            payload: {
              incidentId: data[Object.keys(data)[0]].incidentUuid,
              ticketId: data[Object.keys(data)[0]].ticketUuid,
              property: "id",
              value: data[Object.keys(data)[0]].ticket.id,
            },
          });
        }
      }
    },
  });
  const [updateTicketConditionAllFields] = useMutation(
    UPDATE_TICKET_CONDITION,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  const [updateSpeedMeasurement] = useMutation(UPDATE_SPEED_MEASUREMENT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [removeVehicleFromIncident] = useMutation(
    REMOVE_VEHICLE_FROM_INCIDENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );

  /* ****************************Incident Detail********************************* */
  const [updateIncidentDetail] = useMutation(
    UPDATE_INCIDENT_DETAIL_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  /* ****************************Incident Detail Narrative********************************* */
  const [addOrUpdateIncidentDetailNarrative] = useMutation(
    ADD_OR_UPDATE_INCIDENT_NARRATIVE,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (
            data[Object.keys(data)[0]]?.incidentNarrativeUuid?.includes(
              "Offline_"
            )
          ) {
            incidentDispatch({
              type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
              payload: {
                incidentId: data[Object.keys(data)[0]].incidentUuid,
                narrativeId: data[Object.keys(data)[0]].incidentNarrativeUuid,
                property: "id",
                value: data[Object.keys(data)[0]].incidentNarrative.id,
              },
            });
          }
        }
      },
    }
  );

  const throttledAddOrUpdateIncidentDetailNarrative = throttleFunction(
    addOrUpdateIncidentDetailNarrative
  );

  const [removeIncidentNarrative] = useMutation(REMOVE_INCIDENT_NARRATIVE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  /* ****************************Incident Offenses********************************* */
  const [updateOffenseInIncident] = useMutation(
    UPDATE_OFFENSE_IN_INCIDENT_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (
            data[Object.keys(data)[0]].incidentOffenseUuid.includes("Offline")
          ) {
            incidentDispatch({
              type: UPDATE_OFFENSE,
              payload: {
                incidentId: data[Object.keys(data)[0]].incidentUuid,
                offenseId: data[Object.keys(data)[0]].incidentOffenseUuid,
                property: "id",
                value: data[Object.keys(data)[0]].incidentOffense.id,
              },
            });
          }
        }
      },
    }
  );

  const throttledUpdateOffenseInIncident = throttleFunction(
    updateOffenseInIncident
  );

  const [removeOffenseFromIncident] = useMutation(
    REMOVE_OFFENSE_FROM_INCIDENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  /* ****************************Incident Offenses: SVAs********************************* */
  const [updateSvaInOffense] = useMutation(UPDATE_SVA_IN_OFFENSE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        if (
          data[Object.keys(data)[0]].suspectVictimAffiliationUuid.includes(
            "Offline"
          )
        ) {
          incidentDispatch({
            type: UPDATE_SVA_ALL_INCIDENTS,
            payload: {
              offenseId: data[Object.keys(data)[0]].incidentOffenseUuid,
              svaId: data[Object.keys(data)[0]].suspectVictimAffiliationUuid,
              property: "id",
              value: data[Object.keys(data)[0]].suspectVictimAffiliation.id,
            },
          });
        }
      }
    },
  });

  const throttledAddSvaInOffense = throttleFunction(updateSvaInOffense);

  const [removeSvaFromOffense] = useMutation(REMOVE_SVA_FROM_OFFENSE, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  /* ****************************Officer In Incident********************************* */
  const [addOrUpdateOfficerInIncident] = useMutation(
    ADD_OR_UPDATE_OFFICER_IN_INCIDENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (
            data[Object.keys(data)[0]].officerIncidentSpecificUuid.includes(
              "Offline_"
            )
          )
            incidentDispatch({
              type: UPDATE_OIS,
              payload: {
                incidentId: data[Object.keys(data)[0]].incidentUuid,
                oisId: data[Object.keys(data)[0]].officerIncidentSpecificUuid,
                property: "id",
                value: data[Object.keys(data)[0]].officerIncidentSpecific.id,
              },
            });
        }
      },
    }
  );
  const [setOfficerIncidentTimes] = useMutation(SET_OFFICER_INCIDENT_TIMES, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  const [setStatus] = useMutation(SET_STATUS, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  /* ****************************Incident Arrests********************************* */
  const [updateArrestInIncident] = useMutation(
    UPDATE_ARREST_INCIDENT_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (
            data[Object.keys(data)[0]].incidentArrestUuid.includes("Offline")
          ) {
            incidentDispatch({
              type: UPDATE_ARREST,
              payload: {
                incidentId: data[Object.keys(data)[0]].incidentUuid,
                arrestId: data[Object.keys(data)[0]].incidentArrestUuid,
                property: "id",
                value: data[Object.keys(data)[0]].incidentArrest.id,
              },
            });
          }
        }
      },
    }
  );

  const throttledUpdateArrestInIncident = throttleFunction(
    updateArrestInIncident
  );

  const [removeArrestFromIncident] = useMutation(REMOVE_ARREST_FROM_INCIDENT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  /* ****************************Arrest Charges********************************* */
  const [updateChargeInArrest] = useMutation(
    UPDATE_CHARGE_IN_ARREST_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (data[Object.keys(data)[0]].arrestChargeUuid.includes("Offline")) {
            incidentDispatch({
              type: UPDATE_CHARGE_ALL_INCIDENTS,
              payload: {
                arrestId: data[Object.keys(data)[0]].incidentArrestUuid,
                chargeUuid: data[Object.keys(data)[0]].arrestChargeUuid,
                property: "id",
                value: data[Object.keys(data)[0]].arrestCharge.id,
              },
            });
          }
        }
      },
    }
  );

  const throttledUpdateChargeInArrest = throttleFunction(updateChargeInArrest);

  const [removeChargeFromArrest] = useMutation(REMOVE_CHARGE_FROM_ARREST, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });
  /* ****************************Incident Property********************************* */
  const [updatePropertyInIncident] = useMutation(
    UPDATE_PROPERTY_IN_INCIDENT_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (data[Object.keys(data)[0]].propertyUuid.includes("Offline")) {
            incidentDispatch({
              type: UPDATE_PROPERTY,
              payload: {
                incidentId: data[Object.keys(data)[0]].incidentUuid,
                incidentPropertyId: data[Object.keys(data)[0]].propertyUuid,
                property: "id",
                value: data[Object.keys(data)[0]].property.id,
              },
            });
          }
        }
      },
    }
  );
  const [removePropertyFromIncident] = useMutation(
    REMOVE_PROPERTY_FROM_INCIDENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  /* ****************************Incident Property Custody Chain********************************* */
  const [updateCustodyChainInProperty] = useMutation(
    UPDATE_CUSTODY_CHAIN_IN_PROPERTY_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (data[Object.keys(data)[0]].custodyChainUuid.includes("Offline")) {
            incidentDispatch({
              type: UPDATE_CUSTODY_CHAIN,
              payload: {
                incidentPropertyId: data[Object.keys(data)[0]].propertyUuid,
                custodyChainId: data[Object.keys(data)[0]].custodyChainUuid,
                property: "id",
                value: data[Object.keys(data)[0]].custodyChain.id,
              },
            });
          }
        }
      },
    }
  );
  const [removeCustodyChainFromProperty] = useMutation(
    REMOVE_CUSTODY_CHAIN_FROM_PROPERTY,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  /* ****************************Incident Property Lab Analysis Instance********************************* */
  const [updateLabAnalysisInstanceInProperty] = useMutation(
    UPDATE_LAB_ANALYSIS_INSTANCE_IN_PROPERTY_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (
            data[Object.keys(data)[0]].labAnalysisInstanceUuid.includes(
              "Offline"
            )
          ) {
            incidentDispatch({
              type: UPDATE_LAB_ANALYSIS,
              payload: {
                incidentPropertyId: data[Object.keys(data)[0]].propertyUuid,
                labAnalysisId:
                  data[Object.keys(data)[0]].labAnalysisInstanceUuid,
                property: "id",
                value: data[Object.keys(data)[0]].labAnalysisInstance.id,
              },
            });
          }
        }
      },
    }
  );
  const [removeLabAnalysisInstanceFromProperty] = useMutation(
    REMOVE_LAB_ANALYSIS_INSTANCE_FROM_PROPERTY,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
        }
      },
    }
  );
  /* ****************************Incident Review********************************* */
  const [updateIncidentReview] = useMutation(
    UPDATE_INCIDENT_REVIEW_ALL_FIELDS,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (
            data[Object.keys(data)[0]]?.incidentReviewUuid.includes("Offline")
          ) {
            incidentDispatch({
              type: UPDATE_INCIDENT_REVIEW,
              payload: {
                incidentId: data[Object.keys(data)[0]].incidentUuid,
                incidentReviewId: data[Object.keys(data)[0]].incidentReviewUuid,
                property: "id",
                value: data[Object.keys(data)[0]].incidentReview.id,
              },
            });
          }
        }
      },
    }
  );
  /* ****************************NIC Entries in Incident********************************* */
  const [addOrUpdateNicEntry] = useMutation(ADD_OR_UPDATE_NIC_ENTRY, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        if (data[Object.keys(data)[0]].nicEntryUuid.includes("Offline_")) {
          incidentDispatch({
            type: UPDATE_NIC,
            payload: {
              incidentId: data[Object.keys(data)[0]].incidentUuid,
              nicEntryId: data[Object.keys(data)[0]].nicEntryUuid,
              property: "id",
              value: data[Object.keys(data)[0]].nicEntry.id,
            },
          });
        }
      }
    },
  });

  const throttledAddOrUpdateNicEntry = throttleFunction(addOrUpdateNicEntry);

  const [removeNicEntry] = useMutation(REMOVE_NIC_ENTRY);

  /* ****************************PersonAutoSuggest Mutations********************************* */
  const [addOrUpdatePersonInIncident] = useMutation(
    ADD_OR_UPDATE_PERSON_IN_INCIDENT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          incidentDispatch({
            type: UPDATE_PIS,
            payload: {
              incidentId: data[Object.keys(data)[0]].incidentUuid,
              pisUuid: data[Object.keys(data)[0]].personIncidentSpecificUuid,
              pisId: data[Object.keys(data)[0]].personIncidentSpecific.id,
              property: "person",
              value: data[Object.keys(data)[0]].personIncidentSpecific.person,
            },
          });
        }
      },
    }
  );

  const throttledAddOrUpdatePersonInIncident = throttleFunction(
    addOrUpdatePersonInIncident
  );

  const [updatePerson] = useMutation(ADD_OR_UPDATE_PERSON, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        let person = data.addOrUpdatePerson.person;
        person.uuid = data.addOrUpdatePerson.personUuid;
        if (person.uuid.includes("Offline_")) {
          //map through all incidents and all persons to update the id... ouch
        }
        // addOrUpdatePersonInIncident({ variables: { input: { incidentId: incidentId, personId: person.id ? person.id : person.uuid, personIncidentSpecificId: pisId } } })
      }
    },
  });

  const throttledUpdatePerson = throttleFunction(updatePerson);

  /* ****************************Address Alert Mutations********************************* */
  const [addAddressAlertMutation] = useMutation(ADD_ADDRESS_ALERT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        if (data[Object.keys(data)[0]].addressAlertUuid.includes("Offline_")) {
          incidentDispatch({
            type: UPDATE_INCIDENT_ADDRESS_ALERT,
            payload: {
              addressId: data[Object.keys(data)[0]].addressUuid,
              addressAlertId: data[Object.keys(data)[0]].addressAlertUuid,
              property: "id",
              value: data[Object.keys(data)[0]].addressAlert.id,
            },
          });
        }
      }
    },
  });

  const throttledAddAddressAlertMutation = throttleFunction(
    addAddressAlertMutation
  );

  const [removeAddressAlert] = useMutation(REMOVE_ADDRESS_ALERT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });

  /* ****************************Person Alert Mutations********************************* */
  const [addPersonAlert, { data: personAlertData }] = useMutation(
    ADD_PERSON_ALERT,
    {
      context: { serializationKey: "incidentQueue" },
      onCompleted: data => {
        if (data) {
          responseErrorHandler(data);
          if (data[Object.keys(data)[0]].personAlertUuid.includes("Offline_")) {
            // incidentDispatch({ type: UPDATE_INCIDENT_ADDRESS_ALERT, payload: { addressId: data[Object.keys(data)[0]].addressUuid, addressAlertId: data[Object.keys(data)[0]].addressAlertUuid, property: 'id', value: data[Object.keys(data)[0]].addressAlert.id } })
          }
        }
      },
    }
  );

  const throttledAddPersonAlert = throttleFunction(addPersonAlert);

  const [removePersonAlert] = useMutation(REMOVE_PERSON_ALERT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });

  /* ****************************Person Alert Mutations********************************* */
  const [addVehicleAlert] = useMutation(ADD_VEHICLE_ALERT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
        if (data[Object.keys(data)[0]].vehicleAlertUuid.includes("Offline_")) {
          // incidentDispatch({ type: UPDATE_INCIDENT_ADDRESS_ALERT, payload: { addressId: data[Object.keys(data)[0]].addressUuid, addressAlertId: data[Object.keys(data)[0]].addressAlertUuid, property: 'id', value: data[Object.keys(data)[0]].addressAlert.id } })
        }
      }
    },
  });

  const throttledAddVehicleAlert = throttleFunction(addVehicleAlert);

  const [removeVehicleAlert] = useMutation(REMOVE_VEHICLE_ALERT, {
    context: { serializationKey: "incidentQueue" },
    onCompleted: data => {
      if (data) {
        responseErrorHandler(data);
      }
    },
  });

  return (
    <MutationContext.Provider
      value={{
        updateIncidentNumber,
        updateCallType,
        updateCallPriority,
        updateIncidentPriority,
        updateCallOrigin,
        updateCallTime,
        updateIncidentAddress,
        updateCallArea,
        updateCallTeam,
        updateRollCall,
        updateCallCancelled,
        updateStatewideEvents,
        updateDrugTypes,
        updatePold,
        updateIncidentFlags,
        updateOpiateBlocker,
        updateMentalHealth,
        updateDomv,
        updateCargoTheft,
        setNarratives,
        setQueryReturns,
        addPis,
        throttledAddPis,
        updatePisBac,
        updatePisIncidentInvolvement,
        updatePisPerson,
        updatePisClothing,
        updatePisComputerUse,
        updatePisDocStatus,
        updatePisDrugTypes,
        updatePisIbrResidentType,
        updatePisInjuryTypes,
        updatePisOpiateBlocker,
        updatePisOrphanage,
        updatePisPaperwork,
        updatePisSealed,
        updatePisStateTakenBy,
        updatePisStatementType,
        updatePisVictimType,
        updatePisWeaponType,
        updatePersonOrganization,
        updatePersonFirstName,
        updatePersonMiddleName,
        updatePersonLastName,
        updatePersonSuffix,
        updatePersonJuvenile,
        updatePersonDob,
        updatePersonHomeAddress,
        updatePersonPobAddress,
        updatePersonMailingAddress,
        updatePersonEmployerAddress,
        updatePersonGender,
        updatePersonNibrsGender,
        updatePersonRace,
        updatePersonHeight,
        updatePersonWeight,
        updatePersonSchool,
        updatePersonBuild,
        updatePersonAlias,
        updatePersonHairColor,
        updatePersonEyeColor,
        updatePersonFacialHair,
        updatePersonHairLength,
        updatePersonDistinguishingCharacteristics,
        updatePersonDeceased,
        updatePersonSid,
        updatePersonFbi,
        updatePersonCell,
        updatePersonPhone,
        updatePersonEmail,
        updatePersonDriversLicense,
        updatePersonLicenseState,
        updatePersonIbrGangAffiliations,
        updatePersonIbrRace,
        updatePersonEmployer,
        updatePersonGroups,
        updateVisAbandoned,
        updateVisImpounded,
        updateVisOperator,
        updateVisReasonSeized,
        updateVisSuspectDriven,
        updateVisWrecker,
        updateVisTowingDestination,
        updateVisUsedInCrime,
        updateVisVehicleOfInterest,
        updateVisVehicleRole,
        updateVisPosition,
        updateVehicleAllFields,
        updateVehicleDescription,
        updateVehicleOwner,
        updateVehiclePlateType,
        updateVehicleValue,
        updateVehicleColor,
        updateVehicleMake,
        updateVehicleModel,
        updateVehiclePlate,
        updateVehicleState,
        updateVehicleVin,
        updateVehicleYear,
        generateTicketNumber,
        updateTicketAccident,
        updateTicketActualSpeed,
        updateTicketCdl,
        updateTicketCode,
        updateTicketCommercialVehicle,
        updateTicketCurrentStatus,
        updateTicketCvHazardFee,
        updateTicketDefendantActions,
        updateTicketDefendantParent,
        updateTicketDeliveredTo,
        updateTicketDispositionPenaltyAmount,
        updateTicketFatality,
        updateTicketViolationType,
        updateTicketHazmat,
        updateTicketHighway,
        updateTicketIssuedAt,
        updateTicketIssuedTo,
        updateTicketIssuedToAddress,
        updateTicketLocked,
        updateTicketIsWarning,
        updateTicketMailingAddressVerified,
        updateTicketMunicipalOrdinance,
        updateTicketMunicipality,
        updateTicketNarrative,
        updateTicketOfficer,
        updateTicketOperator,
        updateTicketPassengerTicketEvidence,
        updateTicketPassengerTicketOutcome,
        updateTicketPassengerTicketSearch,
        updateTicketPenalty,
        updateTicketPenaltyMax,
        updateTicketPenaltyMin,
        updateTicketPerceivedRace,
        updateTicketPoints,
        updateTicketPostedLimit,
        updateTicketRelativeCrimeCharge,
        updateTicketReliefActComment,
        updateTicketReliefActType,
        updateTicketRestitution,
        updateTicketSeatBeltOccurrence,
        updateTicketSeatBeltViolation,
        updateTicketSpeedMeasurement,
        updateTicketDeliveryType,
        updateTicketEvidence,
        updateTicketLocation,
        updateTicketNumber,
        updateTicketOutcome,
        updateTicketSearch,
        updateTicketStatus,
        updateTicketStop,
        updateTicketFederalViolationCode,
        updateTicketTrespassRequestor,
        updateTicketTrespassUntil,
        updateTicketUofInjuryDetails,
        updateTicketUofInstance,
        updateTicketUofInstanceTypes,
        updateTicketVehicle,
        updateTicketViolationDate,
        updateTicketWaiver,
        updateTicketAllFields,
        updateTicketWeightLimit,
        updateTicketViolationOccurrence,
        updateTicketConditionAllFields,
        updateSpeedMeasurement,
        removeVehicleFromIncident,
        updateIncidentDetail,
        addOrUpdateIncidentDetailNarrative,
        throttledAddOrUpdateIncidentDetailNarrative,
        removeIncidentNarrative,
        updateOffenseInIncident,
        throttledUpdateOffenseInIncident,
        removeOffenseFromIncident,
        updateSvaInOffense,
        throttledAddSvaInOffense,
        removeSvaFromOffense,
        addOrUpdateOfficerInIncident,
        setOfficerIncidentTimes,
        setStatus,
        updateArrestInIncident,
        throttledUpdateArrestInIncident,
        removeArrestFromIncident,
        updateChargeInArrest,
        throttledUpdateChargeInArrest,
        removeChargeFromArrest,
        updatePropertyInIncident,
        removePropertyFromIncident,
        updateCustodyChainInProperty,
        removeCustodyChainFromProperty,
        updateLabAnalysisInstanceInProperty,
        removeLabAnalysisInstanceFromProperty,
        updateIncidentReview,
        addOrUpdateNicEntry,
        throttledAddOrUpdateNicEntry,
        removeNicEntry,
        addOrUpdatePersonInIncident,
        throttledAddOrUpdatePersonInIncident,
        updatePerson,
        throttledUpdatePerson,
        addAddressAlertMutation,
        throttledAddAddressAlertMutation,
        removeAddressAlert,
        addPersonAlert,
        throttledAddPersonAlert,
        removePersonAlert,
        personAlertData,
        addVehicleAlert,
        throttledAddVehicleAlert,
        removeVehicleAlert,
      }}
    >
      {props.children}
    </MutationContext.Provider>
  );
};
export default MutationContextProvider;
